import { render, staticRenderFns } from "./OrdersLayout.vue?vue&type=template&id=491f4010&"
import script from "./OrdersLayout.vue?vue&type=script&lang=ts&"
export * from "./OrdersLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports